import Card from "react-bootstrap/Card";
import { REPORT_BASE_PATH } from "./Api";
import './custom2.css';


  
  export function Downloads() {
  
    // let changedr = new Array();
    // for(var k in recommendations){
    //     changedr.push({key:k,value:recommendations[k]})
    // }
    // recommendations=changedr;

    // const summary = recommendations.filter(s => s.value[5] > 1).reduce((acc, cur) => {
    //   return [acc[0] + cur.value[6], acc[1] + cur.value[7]]
    // }, [0, 0]);
  
    const ulStyle = { width: '100%', listStyleType: 'none' }
    const liStyle = { color: 'black', fontSize: '16px', borderBottom: '1px solid #eee' }
    var accountId = JSON.parse(localStorage.getItem("userInfo")).accountId;

    return (

      <div className="container mainPanel" >
      <div className="row">
        <div className="col-md-8 leftPaner" >
          <br></br>
        <Card >
          <Card.Body>
            <Card.Title style={{ color: "green" }}>Downloadable Reports</Card.Title>
            <Card.Subtitle className="mb-2 text-muted">
            </Card.Subtitle>
            <Card.Text>
  
            </Card.Text>
            <ul style={ulStyle}>
              <li>
                <a href={REPORT_BASE_PATH+"/dumps/outfile_"+accountId+".csv"}>Last 1 Year Sales Data(csv)</a>
              </li>

              <li>
              <a href={REPORT_BASE_PATH+"/eda/eda_"+accountId+".csv"}>EDA Dump(csv)</a>
              </li>

              
            
            </ul>
          </Card.Body>
        </Card>
        </div>
        </div>
        </div>
  
    )
  }
  